import 'css-chunk:src/app/components/StatisticsCard/Loading.scss';export default {
  "Loading": "_Loading_ke5iz_1",
  "visible": "_visible_ke5iz_14",
  "largeStat": "_largeStat_ke5iz_20",
  "smallStat": "_smallStat_ke5iz_23",
  "link": "_link_ke5iz_29"
};